// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__QLocl","alert":"SettungsInbox_alert__3CMto"};